import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from "../components/mensajes";
import axios from "axios";
import moment from "moment";
import { Dimmer } from "../components/spinner";

const CatalogoOrdenesdePagosPlanillas = (props) => {
  let op = require("../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const btnCancela = useRef();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [values, setValues] = useState({});
  const [activo, setActivo] = useState(true);
  const [itemSelect, setItemSelect] = useState(-1);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const headCells = [
    { label: "CÓDIGO ORDEN", textAlign: "center" },
    { label: "CÓDIGO COMPROMISO", textAlign: "center" },
    /*  { label: 'FECHA', textAlign: 'center' }, */
    { label: "PROVEEDOR", textAlign: "center" },
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableScroll(records, headCells, filterFn);

  //const norden = espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4 ? false : true;
  const norden = true;
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        }

        const search = target.value.trim().toLowerCase();

        return items.filter((x) => {
          const proveedor = (x.proveedor || "").toLowerCase();
          const numOrden = (x.numordenpago || "").toLowerCase();
          const idOrden = (x.idordenpago || "").toLowerCase();
          const idCompromiso = (x.idcompromiso || "").toLowerCase();
          const fecha = moment.utc(x.fecha).format("DD/MM/YYYY");

          return (
            proveedor.includes(search) ||
            numOrden.includes(search) ||
            idOrden.includes(search) ||
            idCompromiso.includes(search) ||
            fecha.includes(target.value)
          );
        });
      },
    });
  };
  const seleccionarOrdenesPagos = () => {
    let orden = norden ? "numordenpago" : "idordenpago";
    let endpoint = `${op.conexion}/api/catalogo/seleccionarordenpagoplanilla?idefi=${idefiscal}&orden=${orden}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          var data = [];
          for (let i = 0; i < response.data.length; i++) {
            data.push({
              idproveedor: response.data[i].idproveedor,
              numordenpago: response.data[i].numordenpago,
              proveedor: response.data[i].proveedor,
              //ubicacion: response.data[i].ubicacion,
              fecha: response.data[i].fecha,
              idcompromiso: response.data[i].idcompromiso,
              idordenpago: response.data[i].idordenpago,
              tipo: response.data[i].tipo,
              //concepto: response.data[i].concepto,
            });
          }
          setRecords(data);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };
  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setItemSelect("");
    setActivo(true);
  };
  const cancelar = () => {
    blanquear();
    props.onHideCancelar();
  };
  const selectOrden = () => {
    var numordenpago = values[0].numordenpago;
    // var proveedor = values[0].proveedor;
    var idproveedor = values[0].idproveedor;
    //var ubicacion = values[0].ubicacion;
    var fecha = values[0].fecha;
    var idcompromiso = values[0].idcompromiso;
    var idordenpago = values[0].idordenpago;
    var tipo = values[0].tipo;
    //var concepto = values[0].concepto;
    blanquear();
    props.onHideAceptar(
      numordenpago,
      idproveedor,
      fecha,
      idcompromiso,
      idordenpago,
      tipo,
    );
    props.onHideCancelar();
  };

  const seleccionarFila = (index) => (e) => {
    e.preventDefault();
    setItemSelect(index);
    setActivo(false);
    var numordenpago = recordsAfterPagingAndSorting()[index].numordenpago;
    var razonsocial = recordsAfterPagingAndSorting()[index].razonsocial;
    var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;
    //var ubicacion = recordsAfterPagingAndSorting()[index].ubicacion;
    var fecha = recordsAfterPagingAndSorting()[index].fecha;
    var idcompromiso = recordsAfterPagingAndSorting()[index].idcompromiso;
    var idordenpago = recordsAfterPagingAndSorting()[index].idordenpago;
    var tipo = recordsAfterPagingAndSorting()[index].tipo;
    //var concepto = recordsAfterPagingAndSorting()[index].concepto;
    var datos = [];
    datos.push({
      numordenpago,
      razonsocial,
      idproveedor,
      //ubicacion,
      fecha,
      idcompromiso,
      idordenpago,
      tipo,
      //concepto
    });
    setValues(datos);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="lg"
      backdrop="static"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      keyboard={false}
      onShow={() => {
        seleccionarOrdenesPagos();
      }}
    >
      <Modal.Header className="text-dark">
        <h3 className="fs-2 m-0">Seleccionar Documento</h3>
        <button ref={btnCancela} className="btn btn-sm" onClick={cancelar}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-6 input-group input-group-sm m-0 p-0">
          <input
            type="text"
            onChange={handleSearch}
            className="form-control rounded-pill search-input"
          />
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td className="py-2 text-center" style={{ width: "100px" }}>
                      {norden ? item.numordenpago : item.idordenpago}
                    </td>
                    <td className="py-2 text-center" style={{ width: "100px" }}>
                      {item.idcompromiso}
                    </td>
                    {/*            <td className='py-2 text-center' style={{ width: '150px' }}>{moment.utc(item.fecha).format('DD/MM/YYYY')}</td> */}
                    <td className="py-2 text-start" style={{ width: "250px" }}>
                      {item.proveedor}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded"
          disabled={activo}
          style={{ margin: "5px" }}
          onClick={selectOrden}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoOrdenesdePagosPlanillas;
